import { Pipe, PipeTransform } from '@angular/core';
import { FolderShareFragment } from '@app/models';

@Pipe({
  name: 'filterGroupSharesPipe',
  standalone: false
})
export class FilterGroupSharesPipe implements PipeTransform {
  transform(shares: FolderShareFragment[]): FolderShareFragment[] {
    return shares.filter(share => !share.user && share.group && share.group.id);
  }
}
